import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isLogged: !!localStorage.getItem('token'),
  currentUser: '',
  layers: [],
  sensors: [],
  markers: []
}

const mutations = {
  LOGIN_USER (state) {
    state.isLogged = true
  },

  LOGOUT_USER (state) {
    state.isLogged = false
  },

  currentUser (state, user) {
    state.currentUser = user
  },

  loadSensors (state, sensors) {
    state.sensors = sensors
  },

  loadLayers (state, layers) {
    state.layers = layers
  },

  loadMarkers (state, markers) {
    if (markers.length > 1) {
      for (let i in markers) {
        state.markers.push(markers[i])
      }
    } else {
      state.markers.push(markers)
    }
  },

  removeMarkers (state, markerId) {
    for (let i in state.markers) {
      if (state.markers[i].leafletId === markerId) {
        state.markers.splice(state.markers.indexOf(state.markers[i]), 1)
      }
    }
  }
}

const getters = {
  getCurrentUser (state) {
    return state.currentUser
  },

  getSensors (state) {
    return state.sensors
  },

  getLayers (state) {
    return state.layers
  },

  getMarkers (state) {
    return state.markers
  }

}

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js